import { render, staticRenderFns } from "./Lifestyle.vue?vue&type=template&id=888cc5aa"
import script from "./Lifestyle.vue?vue&type=script&lang=js"
export * from "./Lifestyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports